import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import './styles.scss';

import {goToNextStep, setTestStepAnswers} from 'actions/index';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Test from './Test';

const subSteps = [Intro, Test];

class Skrivehastighet extends React.Component {
	constructor(props) {
		super(props);

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			isSubmitting: false,
			currentSubstepIndex: 0,
		};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade} = this.props;

		const {onGoToNextStep, onSetTestStepAnswers} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			onSetTestStepAnswers(
				TEST_STEPS.SKRIVEHASTIGHET,
				results,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = subSteps[currentSubstepIndex];

		return (
			<div
				className="lit-intro lit-skrivehastighet"
			>
				<h1 className="lit-page-title">{strings.skrivehastighet}</h1>
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					isDldTest={this.props.isDldTest}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
};

export default connect(mapStateToProps, mapDispatchToProps)(Skrivehastighet);
